
const firebaseConfig = {
  // apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_MESSING_SENDER_ID,
  // appId: process.env.REACT_APP_APP_ID,

  // trying but not working .env.local

  apiKey: "AIzaSyBiXOmamyZly4hfro6TdQV08Kffhavqsfg",
  authDomain: "toure-f9d44.firebaseapp.com",
  projectId: "toure-f9d44",
  storageBucket: "toure-f9d44.appspot.com",
  messagingSenderId: "468102887923",
  appId: "1:468102887923:web:a36f985085fd8779a3fa86"
};

export default firebaseConfig;
